/* jshint esversion: 6, -W097 */
/* globals require, module */
'use strict';

const commonModule = require('@utils/common/commonModule');
const cookiesModule = require('@utils/cookies/cookiesModule');
const calloutBannerDirective = require('./calloutBannerDirective');

const calloutBannerModule = angular
    .module('enervee_utils.callout_banner', [
        commonModule.name,
        cookiesModule.name,
    ])
    .directive('calloutBanner', calloutBannerDirective);

module.exports = calloutBannerModule;